import React from "react";
import { arrayMoveImmutable } from "array-move";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from "react-sortable-hoc";
import clsx from "clsx";
import { IconDrag } from "@/components/Icon";
import styles from "./index.module.less";

const DragHandle = SortableHandle(() => (
  <IconDrag size={16} color="#91919F" style={{ cursor: "move" }} />
));

const Option = SortableElement(props => {
  const { checked, readOnly, invisible, title, onChange } = props;

  return (
    <div
      className={clsx(styles.optionLine, { [styles.disabled]: readOnly })}
      style={{ display: invisible === true ? "none" : "" }}
    >
      <DragHandle />
      <div className={styles.inputBox}>
        <FormControlLabel
          style={{ display: "flex" }}
          disabled={readOnly}
          checked={checked}
          onChange={onChange}
          control={<Checkbox color="primary" />}
          label={<span dangerouslySetInnerHTML={{ __html: title }} />}
        />
      </div>
    </div>
  );
});

const OptionList = SortableContainer(props => {
  const { list, onChange } = props;

  return (
    <div className={styles.sortBox}>
      {list
        .filter(v => v.data !== undefined)
        .map((item, index) => {
          return (
            <Option
              index={index}
              key={item.data + item.title}
              id={item.data}
              title={item.title}
              readOnly={item.disabled}
              checked={item.visible}
              invisible={item.invisible}
              onChange={e => onChange(e.target.checked, index)}
            />
          );
        })}
    </div>
  );
});

const Index = React.memo(({ value, onChange }) => {
  const onMove = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return;
    const newList = arrayMoveImmutable(value, oldIndex, newIndex);
    onChange(newList);
  };

  const handleChange = (checked, index) => {
    onChange(
      value.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            visible: checked
          };
        }
        return item;
      })
    );
  };

  return (
    <div className={styles.optionsBox}>
      <OptionList
        useDragHandle
        onSortEnd={onMove}
        list={value}
        onChange={handleChange}
      />
    </div>
  );
});

export default Index;
